import { render, staticRenderFns } from "./RoleSwitcher.vue?vue&type=template&id=6545c1d7"
import script from "./RoleSwitcher.vue?vue&type=script&lang=js"
export * from "./RoleSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports